import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import scrollparent from 'scrollparent';
import { inView } from '../../utils/domUtil';
var ScrollMonitor = /*#__PURE__*/function (_React$Component) {
  function ScrollMonitor() {
    var _this;
    _classCallCheck(this, ScrollMonitor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScrollMonitor, [].concat(args));
    _this.checkViewport = function () {
      if (!_this.node) {
        return;
      }
      if (_this.props.enterViewport && inView(_this.node)) {
        if (!_this._didNotify) {
          _this._didNotify = true;
          _this.props.enterViewport();
        }
      } else {
        _this._didNotify = false;
      }
    };
    return _this;
  }
  _inherits(ScrollMonitor, _React$Component);
  return _createClass(ScrollMonitor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var node = this.node = findDOMNode(this); // eslint-disable-line react/no-find-dom-node
      var parent = this.scrollingParent = scrollparent(node);
      if (parent) {
        parent.addEventListener('scroll', this.checkViewport);
      }
      setTimeout(function () {
        _this2.checkViewport();
      }, 30);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkViewport();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.scrollingParent) {
        this.scrollingParent.removeEventListener('scroll', this.checkViewport);
      }
      delete this.node;
      delete this.scrollingParent;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(React.Component);
export { ScrollMonitor as default };
ScrollMonitor.propTypes = {
  enterViewport: PropTypes.func,
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map
